var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-container",
    { staticClass: "root" },
    [
      _c(
        "w-row",
        [
          _c(
            "w-col",
            { attrs: { xs: "12" } },
            [
              _c(
                "w-row",
                { attrs: { center: "" } },
                [
                  _c("div", { staticClass: "breadcrumb" }, [
                    _vm._v(" Accounts "),
                  ]),
                  _c("w-spacer"),
                  _vm.hasFilters
                    ? _c(
                        "w-chip",
                        {
                          attrs: { closable: "" },
                          on: {
                            close: function ($event) {
                              return _vm.removeFilters()
                            },
                          },
                        },
                        [_vm._v(" Filters active ")]
                      )
                    : _vm._e(),
                  _vm.selectedItems.length != 0
                    ? _c(
                        "w-chip",
                        {
                          attrs: { closable: "" },
                          on: {
                            close: function ($event) {
                              _vm.selectedItems = []
                            },
                          },
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(_vm.selectedItems.length) +
                              " items selected "
                          ),
                        ]
                      )
                    : _vm._e(),
                  _c("w-input", {
                    staticClass: "search-input",
                    attrs: { icon: "search" },
                    model: {
                      value: _vm.filters.searchQuery,
                      callback: function ($$v) {
                        _vm.$set(_vm.filters, "searchQuery", $$v)
                      },
                      expression: "filters.searchQuery",
                    },
                  }),
                  _c(
                    "w-button-bar",
                    [
                      _c(
                        "w-button",
                        {
                          directives: [
                            {
                              name: "tooltip",
                              rawName: "v-tooltip",
                              value: "Open filters",
                              expression: "'Open filters'",
                            },
                          ],
                          on: {
                            click: function ($event) {
                              _vm.filtersOpened = true
                            },
                          },
                        },
                        [_c("w-fa", { attrs: { icon: "filter" } })],
                        1
                      ),
                      _vm.hasPermission("companies.write")
                        ? _c(
                            "w-button",
                            {
                              directives: [
                                {
                                  name: "tooltip",
                                  rawName: "v-tooltip",
                                  value: "Account toevoegen",
                                  expression: "'Account toevoegen'",
                                },
                              ],
                              attrs: { to: "/companies/new" },
                            },
                            [_c("w-fa", { attrs: { icon: "plus" } })],
                            1
                          )
                        : _vm._e(),
                      _c(
                        "w-button",
                        {
                          directives: [
                            {
                              name: "tooltip",
                              rawName: "v-tooltip",
                              value: _vm.showInfoTooltTip,
                              expression: "showInfoTooltTip",
                            },
                          ],
                          attrs: {
                            disabled: _vm.editDisabled,
                            to: _vm.showInfoLink,
                          },
                        },
                        [_c("w-fa", { attrs: { icon: "eye" } })],
                        1
                      ),
                      _vm.hasPermission("companies.write")
                        ? _c(
                            "w-button",
                            {
                              directives: [
                                {
                                  name: "tooltip",
                                  rawName: "v-tooltip",
                                  value: "Account bewerken",
                                  expression: "'Account bewerken'",
                                },
                              ],
                              attrs: {
                                disabled: _vm.editDisabled,
                                to: _vm.editLink,
                              },
                            },
                            [_c("w-fa", { attrs: { icon: "pen" } })],
                            1
                          )
                        : _vm._e(),
                      _vm.hasPermission("companies.write")
                        ? _c(
                            "w-button",
                            {
                              directives: [
                                {
                                  name: "tooltip",
                                  rawName: "v-tooltip",
                                  value: "Account verwijderen",
                                  expression: "'Account verwijderen'",
                                },
                              ],
                              attrs: { disabled: _vm.editDisabled },
                              on: {
                                click: function ($event) {
                                  return _vm.deleteCompany()
                                },
                              },
                            },
                            [_c("w-fa", { attrs: { icon: "trash" } })],
                            1
                          )
                        : _vm._e(),
                      _c(
                        "w-button",
                        {
                          directives: [
                            {
                              name: "tooltip",
                              rawName: "v-tooltip",
                              value: "Download CSV",
                              expression: "'Download CSV'",
                            },
                          ],
                          attrs: { disabled: _vm.downloadingCsv },
                          on: {
                            click: function ($event) {
                              return _vm.downloadExport()
                            },
                          },
                        },
                        [_c("w-fa", { attrs: { icon: "download" } })],
                        1
                      ),
                      _c(
                        "w-button",
                        {
                          directives: [
                            {
                              name: "tooltip",
                              rawName: "v-tooltip",
                              value: "Ticket aanmaken",
                              expression: "'Ticket aanmaken'",
                            },
                          ],
                          attrs: {
                            disabled: !_vm.selectedItems.length,
                            to: "/ticket/new?companyId=" + _vm.companyId,
                          },
                        },
                        [_c("w-fa", { attrs: { icon: "life-ring" } })],
                        1
                      ),
                      _vm.isAdmin
                        ? _c(
                            "w-button",
                            {
                              directives: [
                                {
                                  name: "tooltip",
                                  rawName: "v-tooltip",
                                  value:
                                    "Verplaatst naar db2 maar niet verwijderde dossiers",
                                  expression:
                                    "'Verplaatst naar db2 maar niet verwijderde dossiers'",
                                },
                              ],
                              attrs: { to: "/moved-but-not-deleted-dossiers" },
                            },
                            [_c("w-fa", { attrs: { icon: "recycle" } })],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-row",
        { staticStyle: { "flex-grow": "1", "flex-shrink": "1" } },
        [
          _c(
            "w-col",
            { attrs: { xs: "12" } },
            [
              _vm.isFetching ? _c("app-fetching-spinner-overlay") : _vm._e(),
              _c("w-data-table", {
                staticStyle: {
                  "flex-grow": "1",
                  height: "calc(100vh - 185px)",
                },
                attrs: {
                  items: _vm.companies,
                  columns: _vm.columns,
                  "order-column": _vm.orderColumn,
                  "selected-items": _vm.selectedItems,
                  "order-direction": _vm.orderDirection,
                },
                on: {
                  order: function ($event) {
                    return _vm.onOrder($event)
                  },
                  "item-clicked": function ($event) {
                    return _vm.onButtonClickShowInfo($event)
                  },
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-row",
        [
          _c(
            "w-col",
            { attrs: { xs: "12" } },
            [
              _c(
                "w-row",
                [
                  _c("w-select", {
                    attrs: { items: _vm.limits, up: true },
                    model: {
                      value: _vm.limit,
                      callback: function ($$v) {
                        _vm.limit = $$v
                      },
                      expression: "limit",
                    },
                  }),
                  _c(
                    "w-col",
                    {
                      staticClass: "amountShown",
                      attrs: { xs: "6", md: "3", lg: "2" },
                    },
                    [
                      _c("span", [
                        _vm._v(" " + _vm._s(_vm.showTotalRecordsText) + " "),
                      ]),
                    ]
                  ),
                  _c("w-spacer"),
                  _c(
                    "w-col",
                    { attrs: { xs: "12", md: "6", lg: "4" } },
                    [
                      _c(
                        "w-row",
                        [
                          _c("w-spacer"),
                          _c("w-pagination", {
                            attrs: {
                              value: _vm.page,
                              "max-shown-pages": 5,
                              "total-pages": _vm.pageCount,
                            },
                            on: {
                              input: function ($event) {
                                return _vm.setPage($event)
                              },
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-modal",
        {
          model: {
            value: _vm.filtersOpened,
            callback: function ($$v) {
              _vm.filtersOpened = $$v
            },
            expression: "filtersOpened",
          },
        },
        [
          _c("app-company-filters", {
            on: {
              close: function ($event) {
                _vm.filtersOpened = false
              },
            },
            model: {
              value: _vm.filters,
              callback: function ($$v) {
                _vm.filters = $$v
              },
              expression: "filters",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }